import { Select } from '@99designs/common/components/Select';
import { Field, FieldSet } from 'common/components/Form';
import { connectToStores } from 'fluxible-addons-react';
import { prefillBrief, resetPrefilledFields } from 'launch/actions/designBriefActions';
import DraftStore from 'launch/stores/DraftStore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { intlShape } from 'react-intl';

interface Props {
    previousDraftData?: {
        [key: string]: any;
    };
    value?: string;
}

interface Context {
    intl: {
        formatMessage: (args: { id: string }) => string;
    };
    executeAction(action: () => void): void;
}

class PrefillBriefField extends Component<Props> {
    context: Context;

    static defaultProps = {
        previousDraftData: null,
        value: 'yes',
    };

    static contextTypes = {
        executeAction: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
    };

    formatMessage = (key: string) => {
        return this.context.intl.formatMessage({ id: `generic_design_brief.${key}` });
    };

    handleChange = (value: string) => {
        // Stop auto saving prefill select field
        // because auto saving has a time delay
        // instead, saving prefill field in prefill action
        if (value === 'yes') {
            this.context.executeAction(prefillBrief);
        } else {
            this.context.executeAction(resetPrefilledFields);
        }
    };

    render() {
        const t = this.formatMessage;
        const prefillOptions = [
            { label: t('field.prefill.option_yes'), value: 'yes' },
            { label: t('field.prefill.option_no'), value: 'no' },
        ];

        if (!this.props.previousDraftData) return null;

        return (
            <FieldSet title={t('fieldset.prefill')}>
                <Field
                    title={t('field.prefill.label')}
                    message={t('field.prefill.message')}
                    htmlFor="prefill"
                >
                    <Select
                        id="prefill"
                        value={this.props.value}
                        options={prefillOptions}
                        onChange={({ value }) => this.handleChange(value)}
                    />
                </Field>
            </FieldSet>
        );
    }
}

export default connectToStores(PrefillBriefField, [DraftStore], (context, prop) => {
    const draftStore = context.getStore(DraftStore);

    return {
        previousDraftData: draftStore.previousDraftData,
    };
});
